import React from 'react'
import { motion } from 'framer-motion'
import { FaStar } from 'react-icons/fa'

const TestimonialSection = () => {
  const testimonials = [
    {
      name: 'Rajesh Kumar',
      role: 'Community Leader',
      text: 'MissionMewarSamriddhi has transformed our community. The energy and commitment are truly inspiring!',
      avatar: '👨‍🦱',
      rating: 5,
    },
    {
      name: 'Sneha Joshi',
      role: 'Environmental Activist',
      text: 'Finally, a platform that brings real change. Seeing Udaipur become cleaner is beyond my expectations.',
      avatar: '👩‍💼',
      rating: 5,
    },
    {
      name: 'Vikram Singh',
      role: 'Youth Leader',
      text: 'This movement showed me that every individual can make a massive impact. MissionMewarSamriddhi is the future!',
      avatar: '👨',
      rating: 5,
    },
  ]

  return (
    <section id="testimonials" className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: false }} className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold font-grotesk mb-4">
            <span className="bg-gradient-to-r from-accent-maroon to-accent-maroonDark bg-clip-text text-transparent">
              Inspiring Stories
            </span>
          </h2>
          <p className="text-gray-600 text-lg">Hear from our volunteers and community leaders</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ y: -8 }}
              className="glass-card flex flex-col bg-white/10 border border-gray-200"
            >
              <div className="flex space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} size={16} className="text-accent-gold fill-current" />
                ))}
              </div>

              <p className="text-gray-600 mb-6 flex-grow italic">"{testimonial.text}"</p>

              <div className="flex items-center space-x-4 pt-4 border-t border-accent-maroon/20">
                <div className="text-3xl">{testimonial.avatar}</div>
                <div>
                  <h4 className="font-bold text-gray-800">{testimonial.name}</h4>
                  <p className="text-sm text-gray-500">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TestimonialSection